import { create } from 'zustand';
export const useSyncStore = create(set => ({
    isOnline: true,
    queueLength: 0,
    conflicts: [],
    setOnline: online => set({ isOnline: online }),
    setQueueLength: len => set({ queueLength: Math.max(0, len) }),
    addConflict: conflict => set(state => ({ conflicts: [conflict, ...state.conflicts].slice(0, 200) })),
    resolveConflict: conflictId => set(state => ({
        conflicts: state.conflicts.filter(c => c.id !== conflictId),
    })),
    clearConflicts: () => set({ conflicts: [] }),
}));
